import React from "react";
import Input from "../../../Elements/Input/Input";
import { AREAS } from "../../../../json/section/areas";
import { PUESTOS } from "../../../../json/section/puestos";
import Button from "../../../Elements/Button/Button";

const EditDatosPuesto = ({ values, handleChange }) => {
    const handleFechaEgresoChange = (e) => {
        const fechaEgreso = e.target.value;
        handleChange("fechaEgreso")({ target: { value: fechaEgreso } });
        handleChange("activo")({ target: { value: false } });

        // Marcar último periodo como egresado
        const nuevosPeriodos = [...(values.periodos || [])];
        if (nuevosPeriodos.length > 0) {
            const ultimo = nuevosPeriodos[nuevosPeriodos.length - 1];
            ultimo.fechaEgreso = fechaEgreso;
            ultimo.activo = false;
            handleChange("periodos")({ target: { value: nuevosPeriodos } });
        }
    };

    const handleRecontratar = () => {
        const nuevosPeriodos = [...(values.periodos || [])];
        const historico = nuevosPeriodos.map(p => ({ ...p, activo: false }));
        const nuevo = {
            fechaIngreso: new Date().toISOString().split("T")[0],
            fechaEgreso: null,
            activo: true,
        };
        handleChange("fechaIngreso")({ target: { value: nuevo.fechaIngreso } });
        handleChange("fechaEgreso")({ target: { value: "" } });
        handleChange("activo")({ target: { value: true } });
        handleChange("periodos")({ target: { value: [...historico, nuevo] } });
    };

    return (
        <div className="seccion-formulario">
            <h4>Datos de Puesto</h4>
            <div className="row g-3">
                <div className="col-md-6">
                    <Input
                        value={values.numeroEmpleado || ""}
                        label="Número de empleado"
                        onChange={handleChange("numeroEmpleado")}
                    />
                </div>
                <div className="col-md-6">
                    <label htmlFor="puesto" className="form-label">Puesto</label>
                    <select
                        id="puesto"
                        name="puesto"
                        value={values.puesto}
                        onChange={handleChange("puesto")}
                        className="form-select"
                    >
                        <option value="">Selecciona puesto...</option>
                        {PUESTOS.map((p) => (
                            <option key={p} value={p}>{p}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-6">
                    <label htmlFor="area" className="form-label">Área</label>
                    <select
                        id="area"
                        name="area"
                        value={values.area}
                        onChange={handleChange("area")}
                        className="form-select"
                    >
                        <option value="">Selecciona área...</option>
                        {AREAS.map((a) => (
                            <option key={a} value={a}>{a}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-6">
                    <Input
                        value={values.fechaIngreso}
                        label="Fecha de ingreso"
                        type="date"
                        onChange={handleChange("fechaIngreso")}
                    />
                </div>

                <div className="col-md-6">
                    <Input
                        value={values.fechaEgreso}
                        label="Fecha de egreso"
                        type="date"
                        onChange={handleFechaEgresoChange}
                    />
                </div>

                {values.fechaEgreso && (
                    <div className="col-md-6 mt-2">
                        <Button
                            text="Recontratar con fecha de hoy"
                            action={handleRecontratar}
                            color="green"
                            fill
                            classNames="btn-sm"
                        />
                    </div>
                )}

                {!values.activo && (
                    <div className="alert alert-warning mt-2" role="alert">
                        Este empleado está marcado como inactivo.
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditDatosPuesto;
